import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { LoadingStates } from "../horariosClubesComponentTypes";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onConfirmar: () => void;
  loadingStates: LoadingStates;
  isAnyOperationInProgress: () => boolean;
}

const ModalConfirmarEliminar: React.FC<Props> = ({
  isOpen,
  toggle,
  onConfirmar,
  loadingStates,
  isAnyOperationInProgress
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirmar Eliminación</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <i className="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
          <h5>¿Estás seguro de que deseas eliminar esta configuración?</h5>
          <p className="text-muted">Esta acción no se puede deshacer.</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button
          color="danger"
          onClick={onConfirmar}
          disabled={isAnyOperationInProgress()}
        >
          {loadingStates.deleting ? <>Eliminando...</> : "Eliminar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirmarEliminar;
